const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.newState };
        case 'sort':
        case 'filter':
        case 'refresh':
            return { ...state, ...action.newState, recOffset: 0, list: [], selectedRows: [] };
        case 'fetching':
            return { ...state, isFetching: true };
        case 'fetched':
            return { ...state, isFetching: false };
        default:
            return state;
    }
};

export default reducer;
